import React, { useState } from 'react';
import { Button } from 'antd';
import styles from './index.module.less';
import cn from 'classnames';
import { IUseEarlyAccessResults } from '@pro/activity/testerClub/useEarlyAccessResults'
import ReviewFormModal from '@pro/activity/testerClub/ResultsContent/ReviewFormModal'
import { isPhone } from 'base/utils/client'
import { RouteEnum } from 'pro/config/routers'
import { generatePath } from 'ava-util/dist/request';
import { useTrans } from 'base/utils/i18n'

type IProps = {
    className?: string;
    results: IUseEarlyAccessResults;
}

const ReviewButton: React.FC<IProps> = (props) => {
    const { className, results } = props;
    const [formVisible, setFormVisible] = useState<boolean>(false);

    const { t } = useTrans()

    return (
        <>
            {!isPhone && (
                <ReviewFormModal
                    results={results}
                    open={formVisible}
                    setOpen={setFormVisible}
                />
            )}

            <div className={cn(className, styles['review-button-warp'], 'text-center')}>
                <Button
                    className={styles['review-button']}
                    type={'primary'}
                    {...(isPhone ? {
                        href: generatePath(RouteEnum.TesterClubReview, {
                            activityId: results.resultsData?.activityGid || ''
                        })
                    } : {
                        onClick: () => setFormVisible(true)
                    })}
                >
                    {t('web_early_access_reclaim_points')}
                </Button>
            </div>
        </>

    );
};

export default ReviewButton